<main>
  <ng-component></ng-component>
</main>



